import { useMutation, useQuery } from '@tanstack/react-query';
import { webgwjsInstance, webgwInstance } from '../redux/request/request';
import { getAccessToken } from "../helpers/authHelper";

type CheckEmailResponse = Partial<{
  accountId: number
  upnEmail: string
  accountEnabled: boolean
  authMode: string
  superPlusAdmin: boolean
  authenticationPath: string
  redirectUrl: string
}>;

type CheckEmailVariables = {
  upnEmail: string
};

const useCheckEmail = (options = {}) => useMutation({
  mutationFn: async ({ upnEmail }: CheckEmailVariables) => {
    console.log(upnEmail)
    const response = await webgwjsInstance.post<CheckEmailResponse>(
      '/api/v1/user/login/email-pre-check',
      { upnEmail },
    );

    return response.data;
  },
  ...options,
});

export type UpdateMerchantMemberReferralVariables = {
  merchantId: string | number
  allowMemberReferral: boolean
};

const useUpdateMerchantMemberReferral = (options = {}) => useMutation({
  mutationFn: async (data: UpdateMerchantMemberReferralVariables) => {
    const response = await webgwInstance.put(
      '/api/v1/merchant/member-referral/allow',
      data,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      },
    );

    return response.data;
  },
  ...options,
});

export type UpdateShopAcceptSCouponSDollarVariables = {
  shopId: string | number;
  participatesInSDollar: boolean;
};

const useUpdateShopAcceptSCouponSDollar = (options = {}) => useMutation({
  mutationFn: async (data: UpdateShopAcceptSCouponSDollarVariables) => {
    const response = await webgwInstance.put(
      '/api/v1/mall/shop/s-dollar/participation ',
      data,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      },
    );

    return response.data;
  },
  ...options,
});

export type ResumeSpendingTransactionVariables = unknown;

const useResumeSpendingTransaction = (options = {}) => useMutation({
  mutationFn: async (data: ResumeSpendingTransactionVariables) => {
    const response = await webgwInstance.put(
      '/api/v1/spending/resume',
      data,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      },
    );

    return response.data;
  },
  ...options,
});

export type SubmitOver14DaysAgoSpendingTransactionVariables = unknown;

const useSubmitOver14DaysAgoSpendingTransaction = (options = {}) => useMutation({
  mutationFn: async (data: SubmitOver14DaysAgoSpendingTransactionVariables) => {
    const response = await webgwInstance.post(
      '/api/v1/spending/submit/old-v2',
      data,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      },
    );

    return response.data;
  },
  ...options,
});

export type SubmitSpendingTransactionVariables = unknown;

const useSubmitSpendingTransaction = (options = {}) => useMutation({
  mutationFn: async (data: SubmitSpendingTransactionVariables) => {
    const response = await webgwInstance.post(
      '/api/v1/spending/submit/v2',
      data,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      },
    );

    return response.data;
  },
  ...options,
});

export type PermissionData = {
  roleCode?: string
  sections?: {
    section?: string
    functions?: {
      function?: string,
      permissionCode?: string,
    }[]
  }[]
}

type PermissionsResponse = {
  data?: PermissionData
}

const usePermissions = (options = {}) => useQuery({
  queryKey: ['permissions'],
  queryFn: async () => {
    const response = await webgwjsInstance.get<PermissionsResponse>(
      '/api/v1/cms/me/permissions',
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return {
      data: {
        ...response.data.data ?? {},
        sections: response.data.data?.sections?.map(section => { 
          return {
            ...section,
            functions: [
              ...(section.functions ?? []),
              ...[
                { section: "MEMBER", function: "ASSIGN_TAG" },
                { section: "SINO_CLUB", function: "VIEW_MEMBER_DETAILS" },
                { section: "SINO_CLUB_PRIVILEGE_MEMBER_REFERRAL", function: "DELETE" },
                { section: "SPENDING_TRANSACTION", function: "CREATE_OLD" },
              ].map(permission => {
                return {
                  ...permission,
                  permissionCode: `${permission.section}.${permission.function}`
                }
              }).filter(permission => permission.section===section.section),
            ].filter(
              permission => permission.permissionCode && ![
                ""
              ].includes(permission.permissionCode)
            ),
          }
        }),
      }
    }
    // return response.data;
  },
  ...options,
});



export {
  useCheckEmail,
  usePermissions,
  useResumeSpendingTransaction,
  useSubmitSpendingTransaction,
  useSubmitOver14DaysAgoSpendingTransaction,
  useUpdateMerchantMemberReferral,
  useUpdateShopAcceptSCouponSDollar,
};
